/** Figma pill size variants — aligned with {@link AncSearchBarSize}. */
export type AncLanguageSelectorSize = 'default' | 'compact' | 'mini';

/** Supported language option for {@link AncLanguageSelectorComponent}. */
export interface AncLanguageOption {
    /** Stable numeric identifier. */
    id: number;
    /** Locale code, e.g. `en`, `fr`. */
    value: string;
    /** Native-script label shown in the menu (not translated). */
    display: string;
    /** Key persisted to user profile / local storage. */
    option_key: string;
    /** Short label shown on the pill, e.g. `en`, `fr`, `ar`. */
    option_value: string;
}

/** Default locale when no selection is provided. */
export const ANC_LANGUAGE_DEFAULT_KEY = 'en';

/** Default language list used across customer and admin apps. */
export const ANC_LANGUAGE_OPTIONS: readonly AncLanguageOption[] = [
    {
        id: 1,
        value: 'en',
        display: 'English',
        option_key: 'en',
        option_value: 'en'
    },
    {
        id: 2,
        value: 'fr',
        display: 'Français',
        option_key: 'fr',
        option_value: 'fr'
    },
    {
        id: 3,
        value: 'th',
        display: 'แบบไทย',
        option_key: 'th',
        option_value: 'th'
    },
    {
        id: 4,
        value: 'ko',
        display: '한국인',
        option_key: 'ko',
        option_value: 'ko'
    },
    {
        id: 5,
        value: 'id',
        display: 'Bahasa',
        option_key: 'id',
        option_value: 'id'
    },
    {
        id: 6,
        value: 'vi',
        display: 'Tiếng Việt',
        option_key: 'vi',
        option_value: 'vi'
    },
    {
        id: 7,
        value: 'ar',
        display: 'العربية',
        option_key: 'ar',
        option_value: 'ar'
    }
];
